;(() => {
  var handles = {
    'seibertron-adult-or-youth-s-o-l-a-g-sports-outdoor-water-resistant-full-finger-touchscreen-gloves': true,
    'seibertron-s-o-l-a-g-1-2-half-finger-gloves': true,
    'seibertron-men-or-women-xxs-to-xxl-fingerless-half-finger-sports-outdoor-tactical-gloves-1': true,
    'seibertron-adult-or-youth-s-o-l-a-g-sports-outdoor-water-resistant-full-finger-touchscreen-gloves-1': true,
    'seibertron-men-or-women-xxs-to-xxl-fingerless-half-finger-sports-outdoor-tactical-gloves': true,
    'seibertron-adult-or-youth-s-o-l-a-g-sports-outdoor-water-resistant-full-finger-touchscreen-gloves-2': true,
    'seibertron-solag-2-0-outdoor-touchscreen-gloves': true,
    'seibertron-tactical-fingerless-leather-gloves': true,
    'seibertron-t-b-f-i-g-mens-tac-gloves': true,
    'seibertron-t-f-f-i-g-2-0-best-tactical-gloves': true,
    'seibertron-t-t-f-i-g-2-0-tactical-fingerless-gloves': true,
    'seibertron-t-t-f-i-g-2-0-mens-tactical-military-gloves-flexible-rubber-knuckle-protective-for-combat-hunting-hiking-airsoft-paintball-motorcycle-motorbike-riding-outdoor-gloves': true
  };
  var productCache = {};
  var inFlight = {};

  function normalize(value) {
    return String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
  }
  function colorFrom(value) {
    var text = normalize(value);
    if (text.indexOf('fluorescent') !== -1 && text.indexOf('yellow') !== -1) return 'fluorescent yellow';
    if (text.indexOf('army') !== -1 && text.indexOf('green') !== -1) return 'army green';
    if (text.indexOf('coyote') !== -1) return 'coyote';
    if (text.indexOf('black') !== -1) return 'black';
    if (text.indexOf('grey') !== -1 || text.indexOf('gray') !== -1) return 'grey';
    if (text.indexOf('white') !== -1) return 'white';
    if (text.indexOf('red') !== -1) return 'red';
    if (text.indexOf('blue') !== -1) return 'blue';
    if (text.indexOf('yellow') !== -1) return 'yellow';
    return text;
  }
  function mediaColor(media) {
    var alt = String(media.alt || '');
    var match = alt.match(/\bcolor\s*:\s*([^|,;\n\r]+)/i);
    return match ? colorFrom(match[1]) : 'all';
  }
  function selectedColor(root) {
    var checked = root.querySelector('[data-auto-visual-option-value] input:checked');
    var label = checked ? checked.closest('[data-auto-visual-option-value]') : null;
    var value = label ? (label.getAttribute('data-auto-visual-option-value') || checked.value || '') : '';
    return colorFrom(value);
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function sized(url, width) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return url;
    }
  }
  function visible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return !el.hidden && el.getAttribute('aria-hidden') !== 'true' && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }
  function mediaId(media) {
    return String(media.id || '').split('/').pop();
  }
  function readSafeCount(root) {
    return String(root.getAttribute('data-safe-gallery-media-ids') || '').split('|').filter(Boolean).length;
  }
  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (inFlight[handle]) return inFlight[handle];
    inFlight[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (product) {
        productCache[handle] = product || null;
        return productCache[handle];
      })
      .catch(function () { return null; });
    return inFlight[handle];
  }
  function groupMedia(product, root) {
    var media = Array.isArray(product && product.media) ? product.media.filter(function (item) { return item && item.media_type === 'image' && item.src; }) : [];
    if (!media.length) return [];
    var selected = selectedColor(root);
    var group = media.filter(function (item) {
      var color = mediaColor(item);
      return color === selected || color === 'all';
    });
    return group.length >= 2 ? group : media.slice(0, Math.min(media.length, 8));
  }
  function setMain(root, media) {
    var main = root.querySelector('[data-auto-main-image]');
    if (!main || !media) return;
    main.src = sized(media.src, 1200);
    main.srcset = '';
    main.alt = media.alt || main.alt || '';
  }
  function ensureThumb(root, wrap, media, index) {
    var id = mediaId(media);
    if (!id) return null;
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(media.src, 1200));
    thumb.setAttribute('data-alt', media.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.hidden = false;
    thumb.setAttribute('aria-hidden', 'false');
    thumb.innerHTML = '<img src="' + escapeHtml(sized(media.src, 160)) + '" alt="' + escapeHtml(media.alt || '') + '" width="76" height="76" loading="' + (index === 0 ? 'eager' : 'lazy') + '">';
    if (thumb.dataset.tacticalFallbackBound !== 'true') {
      thumb.dataset.tacticalFallbackBound = 'true';
      thumb.addEventListener('click', function () {
        setMain(root, media);
        root.querySelectorAll('[data-auto-thumb]').forEach(function (item) {
          item.classList.toggle('is-active', item === thumb);
        });
      });
    }
    return thumb;
  }
  function applyGroup(root, product) {
    var wrap = root.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    var group = groupMedia(product, root);
    if (!group.length) return;
    var ids = {};
    group.forEach(function (media, index) {
      var thumb = ensureThumb(root, wrap, media, index);
      if (thumb) ids[mediaId(media)] = true;
    });
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var show = !!ids[String(thumb.getAttribute('data-media-id') || '')];
      thumb.hidden = !show;
      thumb.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) thumb.style.display = '';
    });
    var active = group[0];
    setMain(root, active);
    root.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === mediaId(active));
    });
  }
  function repair(root, force) {
    var handle = root.getAttribute('data-product-handle') || '';
    if (!handles[handle]) return;
    var safeCount = readSafeCount(root);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-auto-thumb]'));
    var visibleCount = thumbs.filter(visible).length;
    if (!force && safeCount >= 5 && thumbs.length >= 5 && visibleCount >= Math.min(5, safeCount)) return;
    fetchProduct(handle).then(function (product) {
      if (product) applyGroup(root, product);
    });
  }
  function run(force) {
    document.querySelectorAll('.auto-product[data-product-handle]').forEach(function (root) {
      repair(root, force);
    });
  }
  function bind() {
    document.querySelectorAll('.auto-product[data-product-handle]').forEach(function (root) {
      var handle = root.getAttribute('data-product-handle') || '';
      if (!handles[handle] || root.dataset.tacticalGalleryFallbackBound === 'true') return;
      root.dataset.tacticalGalleryFallbackBound = 'true';
      root.addEventListener('change', function (event) {
        if (event.target && event.target.matches('input[name^="options["]')) {
          window.setTimeout(function () { repair(root, true); }, 0);
          window.setTimeout(function () { repair(root, true); }, 450);
          window.setTimeout(function () { repair(root, true); }, 1300);
        }
      });
    });
  }
  function schedule(force) {
    bind();
    run(force);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(false); }, { once: true });
  } else {
    schedule(false);
  }
  [350, 900, 1600, 2800, 5200, 8200].forEach(function (delay) {
    window.setTimeout(function () { schedule(false); }, delay);
  });
})();